import React from 'react';
import DataDisplayOne, { ButtonOne, InputField, makeApiRequest } from "./helper";
import ReportExpensesListOne from "./ReportExpensesListOne";

const COMPONENTDIDMOUNT = 'componentDiMount';
const REPORTS ="reports";
const MONTH ="months";

class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            start_date: '',
            end_date: '',
            report_one: null,
            error_list: [],
            expenses: [],
            try_again_name:"",
            pdf_url: null,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }

    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };

    componentDidMount() {
        try {
        this.setLoaderFunction();
        const token = localStorage.getItem("token");
        setTimeout(
            function () {
                this.closeLoaderFuncion();
            }.bind(this),
            500
        );
        }catch (error) {
            this.state.try_again_name = COMPONENTDIDMOUNT;
            this.enableTryAgain();
          }
    }




    fetchMonthReportData = async () => {
        try {
            const { start_date, end_date } = this.state;
            this.setLoaderFunction();
            const response = await makeApiRequest('api/report/month/profit/loss', 'POST', {
                start_date: start_date,
                end_date: end_date
            });

            if (response.success) {

                this.setState({
                    report_one: response.report_one,
                    expenses: response.expenses,
                    error_list: [],
                });
            } else {

                this.setState({
                    error_list: response.data,
                });
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            this.state.try_again_name=MONTH;
        } finally {
            this.closeLoaderFuncion();
        }
    }

    getMonthReportDataPdf = async () => {
        try {
            const { start_date, end_date } = this.state;
            this.setLoaderFunction();
            const response = await makeApiRequest('api/report/month/profit/loss/pdf', 'POST', {
                start_date: start_date,
                end_date: end_date
            });

            if (response.success) {

                this.setState({
                    pdf_url: response.pdf_url,
                    error_list: [],
                });
                window.open(response.pdf_url, '_blank');
            } else {

                this.setState({
                    error_list: response.data,
                });
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            this.state.try_again_name = REPORTS;
            this.enableTryAgain();
        } finally {
            this.closeLoaderFuncion();
        }
    }

    tryAgain = () => {
        switch (this.state.try_again_name) {
          case COMPONENTDIDMOUNT:
            this.componentDidMount();
            break;
            case REPORTS:
                this.getMonthReportDataPdf();
                break;
                case MONTH:
                this.fetchMonthReportData();
                break;
        }
      }

    startLoader = (isLoading, whenNotSearch) => {

        this.props.progressDialogV(isLoading, whenNotSearch);
    };

    endLoader = () => {

        const isLoading = false;
        const whenNotSearch = false;
        this.props.progressDialogV(isLoading, whenNotSearch);
    };

    handleStartDateChange = (event) => {
        this.setState({ start_date: event.target.value });
    };

    handleEndDateChange = (event) => {
        this.setState({ end_date: event.target.value });
    };

    render() {

        return (
            <div className="p-4">
                {/*loader_status------------------------------------------------------------------------*/}
                {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

                {/*try_again_status-----------------------------------------------------------------------------*/}
                {this.state.try_again_status && (
                    <div className="h-screen flex items-center justify-center bg-white ">
                        <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-red-500">{this.state.error_customize}</p>
                            <button
                                type="button"
                                onClick={this.tryAgain}
                                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                TryAgain
                            </button>
                        </div>
                    </div>
                )}
                {/*try_again_status-----------------------------------------------------------------------------*/}





                {this.state.main_content_status && (
                    <div className="flex flex-col flex-1">
                        <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                <InputField
                                    label="Start Date"
                                    type="Date"
                                    name="start_date"
                                    value={this.state.start_date || ''}
                                    onChange={this.handleStartDateChange}
                                    error={this.state.error_list.start_date}
                                    withStar={true}
                                />
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                <InputField
                                    label="End Date"
                                    type="Date"
                                    name="end_date"
                                    value={this.state.end_date || ''}
                                    onChange={this.handleEndDateChange}
                                    error={this.state.error_list.end_date}
                                    withStar={true}
                                />
                            </div>
                        </div>
                        <div className="mt-2 flex flex-row">
                            <div>
                                <ButtonOne onClick={this.fetchMonthReportData} label="Fetch Report" />
                            </div>
                            <div className="ml-2">
                                <ButtonOne onClick={this.getMonthReportDataPdf} label="Report Pdf" />
                            </div>
                        </div>
                        {this.state.expenses.length > 0 && <ReportExpensesListOne expenses={this.state.expenses} />}
                        {this.state.report_one && (
                            <DataDisplayOne title={'Month Profit and Loss'} dataOneList={this.state.report_one} />)}
                    </div>
                )}
            </div>
        );
    }
}

export default Reports;
